// POS Login Access: the phones the owner allows to sign in to the POS
// (backend routes/pos_login_access.py -> services/pos_access, the ONE rule set).
// The back-office page, the Employees page switch and the Admin PWA all call these.
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || '';
const BASE = `${API}/api/rest/v1/pos-login-access`;

const auth = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const ROLE_LABELS = {
  owner: 'Owner',
  manager: 'Manager',
  waiter: 'Waiter',
  cashier: 'Cashier',
  host: 'Host',
  kitchen: 'Kitchen',
  expo: 'Expo',
};

export const listAccess = (token) => axios.get(BASE, auth(token)).then((r) => r.data);
export const accessHistory = (token) => axios.get(`${BASE}/history`, auth(token)).then((r) => r.data.events || []);
export const addAccess = (token, entries) => axios.post(BASE, { entries }, auth(token)).then((r) => r.data);
export const setAccess = (token, id, allowed) => axios.put(`${BASE}/${id}`, { allowed }, auth(token)).then((r) => r.data);
export const removeAccess = (token, id) => axios.delete(`${BASE}/${id}`, auth(token)).then((r) => r.data);

// "+16289998118" -> "(628) 999-8118"; other countries as stored
export function formatPhone(phone) {
  const p = String(phone || '');
  const m = p.match(/^\+1(\d{3})(\d{3})(\d{4})$/);
  return m ? `(${m[1]}) ${m[2]}-${m[3]}` : p;
}

// The server's answer as words (a string detail, or a detail object's message)
export function detailText(error, fallback) {
  const d = error?.response?.data?.detail ?? error;
  if (typeof d === 'string' && d) return d;
  if (d && typeof d.message === 'string') return d.message;
  return fallback;
}

// A pasted list: one phone per line, optionally "Name, phone, role" (any order of
// name / phone; the role word if it is one of ROLE_LABELS).
export function parsePasted(text, defaultRole = 'waiter') {
  return String(text || '')
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const parts = line.split(/[,;\t]/).map((s) => s.trim()).filter(Boolean);
      const phone = parts.find((s) => (s.match(/\d/g) || []).length >= 10) || '';
      const role = parts.map((s) => s.toLowerCase()).find((s) => ROLE_LABELS[s]) || defaultRole;
      const name = parts.find((s) => s !== phone && !ROLE_LABELS[s.toLowerCase()]) || '';
      return { name, phone: phone || line, role };
    });
}
